module.exports = __webpack_public_path__ + "static/media/settings-icon.df694876.svg";